import type { SVGProps } from 'react';

import RedRock from './RedRock';

export default function MundRedRock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={88}
      height={56}
      viewBox='0 0 88 56'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#mund-red-rock-clip)'>
        <rect
          x='3.50586'
          y='13.8578'
          width='40'
          height='40'
          rx='10'
          transform='rotate(-15 3.50586 13.8578)'
          fill='url(#mund-red-rock-background)'
        />
        <g clipPath='url(#mund-red-rock-mark-clip)'>
          <path
            d='M26.0792 15.3202L25.2331 16.5812C25.1145 16.7583 24.8865 16.8194 24.6952 16.7253L23.3286 16.0524C23.2192 15.9983 23.0896 15.9925 22.9786 16.039C22.2997 16.321 21.6264 16.6682 20.9653 17.0789C17.4753 19.2485 15.2685 23.0547 15.1152 27.1758C14.8352 34.8436 20.5862 40.395 27.1845 40.829C28.5439 40.9176 29.9407 40.7911 31.3287 40.4192C32.7167 40.0473 33.9895 39.4584 35.1226 38.702C39.5819 35.7222 41.8736 30.0987 40.4037 24.6132C38.7165 18.3162 32.6433 14.343 26.375 15.1313C26.2535 15.1472 26.1435 15.2148 26.0742 15.3191L26.0792 15.3202ZM18.1575 31.7824L18.1591 31.7795L21.9777 30.7564C22.1781 30.8671 22.295 30.9311 22.4932 31.0424C23.3447 33.6622 24.4831 35.8833 25.7506 37.5145C26.0005 37.8361 25.705 38.2918 25.3123 38.1897C22.1259 37.3395 19.4068 35.0104 18.1536 31.7858L18.1575 31.7824ZM30.804 38.16C30.778 38.1693 30.7537 38.1758 30.7293 38.1824C30.705 38.1889 30.6806 38.1954 30.6535 38.2003C29.2136 38.467 26.476 35.7235 24.7369 30.4817C24.6605 30.2496 24.795 29.9991 25.0297 29.9362L31.5423 28.1911C31.7769 28.1283 32.0187 28.278 32.0686 28.5172C33.1834 33.9262 32.1821 37.6716 30.804 38.16ZM35.4221 35.4808C35.1358 35.7672 34.6515 35.518 34.7049 35.1153C35.0002 32.9675 34.8463 30.3301 34.1999 27.4838C34.1993 27.4816 34.2015 27.481 34.2015 27.481L33.7111 25.651C33.6504 25.4242 33.4172 25.2889 33.1914 25.3494L18.0256 29.4131C17.771 29.4813 17.5209 29.3004 17.4928 29.0363C17.1496 25.7894 18.3309 22.6274 20.5527 20.4091C20.8412 20.1221 21.3239 20.374 21.2689 20.7796C21.0637 22.2717 21.0762 24.0009 21.3177 25.8761C21.35 26.1296 21.6038 26.2975 21.8495 26.2317L23.2685 25.8515C23.4722 25.7969 23.6037 25.5972 23.5783 25.3871C23.0544 21.0591 23.9684 18.1569 25.1708 17.7299L25.3191 17.6901C26.5739 17.4588 28.8188 19.5145 30.527 23.5253C30.6099 23.7199 30.8215 23.8276 31.0274 23.7725L32.4441 23.3929C32.6898 23.327 32.8263 23.0569 32.7269 22.819C32.0035 21.0753 31.1475 19.5722 30.2254 18.3798C29.9755 18.0582 30.2692 17.5959 30.6603 17.7008C33.8389 18.5483 36.5506 20.8674 37.808 24.0814C37.8128 24.0992 37.8197 24.1164 37.8245 24.1342L38.4114 26.3244C38.4161 26.3421 38.4209 26.3599 38.4234 26.3783C38.9415 29.7904 37.7505 33.1553 35.4215 35.4785L35.4221 35.4808Z'
            fill='url(#mund-red-rock-mark)'
          />
        </g>
      </g>
      <g
        transform='rotate(15 49.3934 9.62883)'
      >
        <RedRock
          x={49.3934}
          y={9.62883}
          width={40}
          height={40}
        />
      </g>
      <defs>
        <linearGradient
          id='mund-red-rock-background'
          x1='23.5059'
          y1='13.8578'
          x2='23.5059'
          y2='53.8578'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29282C' />
          <stop offset='1' stopColor='#100F11' />
        </linearGradient>
        <linearGradient
          id='mund-red-rock-mark'
          x1='10.6945'
          y1='13.8569'
          x2='35.8067'
          y2='35.4541'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='mund-red-rock-clip'>
          <rect
            x='3.50586'
            y='13.8578'
            width='40'
            height='40'
            rx='10'
            transform='rotate(-15 3.50586 13.8578)'
            fill='white'
          />
        </clipPath>
        <clipPath id='mund-red-rock-mark-clip'>
          <rect
            width='30'
            height='30'
            fill='white'
            transform='translate(9.63086 17.3935) rotate(-15)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
